import React from "react";
import { bikes } from "../mock/mock";
import { Fuel, Cog, HardHat, Clock } from "lucide-react";

const Bikes = () => {
  return (
    <section id="bikes" className="pt-8 pb-16 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-orange-600 font-bold text-sm uppercase tracking-[0.2em]">
            Our Fleet
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-black text-neutral-900 leading-tight tracking-tight">
            Bike &amp; Scooty Rental in{" "}
            <span className="text-orange-500">Udupi &amp; Manipal</span>
          </h2>
          <p className="mt-4 text-neutral-600">
            Our well-maintained fleet, available at both our Udupi and Manipal
            branches. Use the Search above for live rates and availability.
          </p>
        </div>

        {/* Scooter grid — informational only */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          data-testid="fleet-grid"
        >
          {bikes.map((bike, idx) => (
            <div
              key={bike.id}
              data-testid={`fleet-card-${idx}`}
              className="group bg-white rounded-2xl border border-neutral-100 overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col"
            >
              <div className="relative h-56 overflow-hidden bg-gradient-to-br from-neutral-100 to-neutral-50 flex items-center justify-center p-4">
                <img
                  src={bike.image}
                  alt={`Rent ${bike.name} in Udupi and Manipal from RR Bros Bike Rental`}
                  loading={idx === 0 ? "eager" : "lazy"}
                  decoding="async"
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider shadow">
                  Scooter
                </div>
              </div>

              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-black text-lg text-neutral-900 leading-tight">
                  {bike.name}
                </h3>

                <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-3 text-xs text-neutral-600">
                  <div className="flex items-center gap-1.5">
                    <Cog className="w-3.5 h-3.5 text-orange-500" />
                    <span>{bike.engine}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <Fuel className="w-3.5 h-3.5 text-orange-500" />
                    <span>{bike.mileage}</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <Clock className="w-3.5 h-3.5 text-orange-500" />
                    <span>24 hrs basis</span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <HardHat className="w-3.5 h-3.5 text-orange-500" />
                    <span>1 helmet free</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Bikes;
